// Severidad del comunicado en lenguaje de producto -> severidad de MUI.
export const SEVERITY_TO_MUI = {
  info: 'info',
  warning: 'warning',
  critical: 'error',
};

export const SEVERITY_OPTIONS = [
  { value: 'info', label: 'Informativo' },
  { value: 'warning', label: 'Aviso' },
  { value: 'critical', label: 'Crítico' },
];

export const muiSeverity = (severity) => SEVERITY_TO_MUI[severity] || 'info';
